"use client";
import ProductCard from "../ProductCard/ProductCard";
import { filterUrlsAccordingToSearchParams } from "@/libs/filterUrlAccordingToSearchParams";
import { useSearchParams } from "next/navigation";
import { getProducts } from "@/apis/products";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import { useEffect } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useSession } from "@/hooks/useSession";

export const ProductMapper = ({ t }) => {
  const [targetRef, isIntersecting] = useIntersectionObserver({ threshold: 1 });
  const { session } = useSession();
  const searchParams = useSearchParams();

  const getFilterParams = (page) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("page", page);
    return filterUrlsAccordingToSearchParams(params, true);
  };

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteQuery({
    queryKey: ["get-products", searchParams.toString()],
    queryFn: async ({ pageParam = 1 }) => {
      const params = getFilterParams(pageParam);
      const response = await getProducts(params);
      return response;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage?.pagination?.current_page < lastPage?.pagination?.last_page
        ? lastPage.pagination.current_page + 1
        : undefined,
  });

  const productList = data?.pages?.flatMap((page) => page.data ?? []) ?? [];

  useEffect(() => {
    if (isIntersecting && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [isIntersecting, hasNextPage, isFetchingNextPage, fetchNextPage]);

  return (
    <>
      {productList.length > 0 ? (
        <div className="row">
          {productList.map((product) => (
            <div
              key={product.id}
              className="xl-4 lg-4 md-4 sm-6 productCardIntersection"
            >
              <ProductCard item={product} t={t} isAuthenticated={!!session} />
            </div>
          ))}
        </div>
      ) : // <div className="emptyCart">
      //   <span>{t["not.found.products"]}</span>
      // </div>
      null}

      {hasNextPage && productList.length > 0 && (
        <div ref={targetRef} className="loadingProduct">
          {t["loading.products"]}...
        </div>
      )}
    </>
  );
};
